import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { locations } from 'services/routes/locations';
import useAuthStore from '../auth';

type AuthProtectedCallback = (...args: Array<unknown>) => unknown;

/**
 * **`callback` must be memoised in order to avoid unnecessary re-renders**
 * */
const useAuthProtectedAction = (callback: AuthProtectedCallback) => {
  const navigate = useNavigate();
  const {
    authStore: { isLoggedIn },
  } = useAuthStore();

  const protectedCallback: AuthProtectedCallback = useCallback(
    (...args) => {
      if (!isLoggedIn) {
        navigate(locations.general.register.pathname(''));
        return;
      }
      callback(...args);
    },
    [isLoggedIn, navigate, callback]
  );

  return protectedCallback;
};

export default useAuthProtectedAction;
